import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { ConfigProvider } from 'antd';
import EditarServidor from './pages/EditarServidor';
import AgregarServidor from './pages/AgregarServidor';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Lista from './pages/Lista';
import Clientes from './pages/Clientes';
import Proyectos from './pages/Proyectos';
import Servicios from './pages/Servicios';
import HistorialCargas from './pages/HistorialCargas';
import MetricasServidor from './pages/MetricasServidor';
import MonitorMySQL from './pages/MonitorMySQL';
import ProyectoDetalle from './pages/ProyectoDetalle';
import ProyectoInfra from './pages/ProyectoInfra';
import MonitorUrl from './pages/MonitorUrl';
import MonitorSsl from './pages/MonitorSsl';
import MonitorDominios from './pages/MonitorDominios';
import Alertas from './pages/Alertas';
import Bitacora from './pages/Bitacora';
import Reportes from './pages/Reportes';
import Infraestructura from './pages/Infraestructura';
import AdminSMTP from './pages/AdminSMTP';
import OllamaMonitor from './pages/OllamaMonitor';
import ServerProcesses from './pages/ServerProcesses';
import ErrorBoundary from './components/ErrorBoundary';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import { selectIsAuthenticated } from './store/authSlice';
import { logOut } from './store/authSlice';
import './App.css';

const antTheme = {
  token: {
    colorPrimary: '#5ddab4',
    borderRadius: 10,
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    colorBgContainer: '#ffffff',
    colorBorderSecondary: '#e8edf5',
  },
};

const AppLayout = ({ onLogout }) => {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className={collapsed ? 'sidebar-collapsed' : ''}>
      <Sidebar
        collapsed={collapsed}
        onCollapse={setCollapsed}
        onLogout={onLogout}
      />
      <Header />
      <div className={`main-layout ${collapsed ? 'sidebar-collapsed' : ''}`}>
        <ErrorBoundary>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/lista" element={<Lista />} />
            <Route path="/clientes" element={<Clientes />} />
            <Route path="/proyectos" element={<Proyectos />} />
            <Route path="/proyecto" element={<ProyectoInfra />} />
            <Route path="/servicios" element={<Servicios />} />
            <Route path="/historial" element={<HistorialCargas />} />
            <Route path="/metricas" element={<MetricasServidor />} />
            <Route path="/mysql" element={<MonitorMySQL />} />
            <Route path="/proyecto/:id" element={<ProyectoDetalle />} />
            <Route path="/url-monitor" element={<MonitorUrl />} />
            <Route path="/ssl-monitor" element={<MonitorSsl />} />
            <Route path="/dominios" element={<MonitorDominios />} />
            <Route path="/alertas" element={<Alertas />} />
            <Route path="/bitacora" element={<Bitacora />} />
            <Route path="/reportes" element={<Reportes />} />
            <Route path="/infraestructura" element={<Infraestructura />} />
            <Route path="/admin/smtp" element={<AdminSMTP />} />
            <Route path="/ollama" element={<OllamaMonitor />} />
            <Route path="/procesos" element={<ServerProcesses />} />
            <Route path="/editar/:id" element={<EditarServidor />} />
            <Route path="/agregar" element={<AgregarServidor />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </ErrorBoundary>
      </div>
    </div>
  );
};

function App() {
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const dispatch = useDispatch();

  const handleLogout = () => {
    dispatch(logOut());
  };

  if (!isAuthenticated) {
    return (
      <ConfigProvider theme={antTheme}>
        <Login />
      </ConfigProvider>
    );
  }

  return (
    <ConfigProvider theme={antTheme}>
      <BrowserRouter>
        <AppLayout onLogout={handleLogout} />
      </BrowserRouter>
    </ConfigProvider>
  );
}

export default App;
